import {createInstance} from './instance'
import {GetApiUrl} from "@/constants/config";

const generalRequest = createInstance(GetApiUrl())

export {generalRequest}

